import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const EMPLOIDUTEMPS_URL = `${backendUrl}/api/emploidutemps/`;

class EmploidutempsService {
	async getAllEmploidutemps() {
		try {
			const response = await axios.get(EMPLOIDUTEMPS_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getEmploidutemps(id) {
		return axios.get(`${EMPLOIDUTEMPS_URL}${id}/`);
	}

	createEmploidutemps(data) {
		return axios.post(EMPLOIDUTEMPS_URL, data).catch((error) => {
			console.error("Erreur lors de la création de l'emploi du temps", error);
			throw error;
		});
	}

	updateEmploidutemps(id, data) {
		return axios.put(`${EMPLOIDUTEMPS_URL}${id}/`, data);
	}

	deleteEmploidutemps(id) {
		return axios.delete(`${EMPLOIDUTEMPS_URL}${id}/`);
	}

	getEmploidutempsOptions() {
		return this.getAllEmploidutemps().then((emploidutempss) => {
			const options = emploidutempss.map((emploidutemps) => ({
				value: emploidutemps.id,
				label: emploidutemps.categorie.toUpperCase()
			}));
			return options;
		});
	}
}

export default new EmploidutempsService();
